import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useContext, useEffect, useState } from 'react';

import { SubscriptionNode } from '../../Common/ConsumerModels/SubcriptionNode';
import { 
  addAttributesFromDraft, 
  addSubscriptionNodeFields,
  filterBySearchQuery, 
  findLeavesOfNodeList, 
} from '../../Common/Helper/subscriptionNodeHelper';

export function useGetAvailableSubscriptionAttributes(
  draftedSubscriptionNodes: SubscriptionNode[],
  environment: number,
  egressOptions: Array<number>,
  searchQuery: string
) {
  const [formattedSubscriptionNodes, setFormattedSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [filteredSubscriptionNodes, setFilteredSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [checkedAttributeCount, setCheckedAttributeCount] = useState<number>(0);
  const [isAttributeSubscriptionLoading, setIsAttributeSubscriptionLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    let cancelled = false;
    setIsAttributeSubscriptionLoading(true);

    let egressOptionFormatted = '';
    egressOptions.forEach((singleEgressOption) => {
      egressOptionFormatted = egressOptionFormatted + ('&egressOptions=' + singleEgressOption);
    });

    httpClient
      .get<SubscriptionNode[]>(
        `${__API_BASE_URL__}/subscriber/availableSubscriptionAttributes?requestEnvironment=${environment}${egressOptionFormatted}`,
        {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        }
      )
      .then(({ data }) => {
        if (cancelled) return;
        const formattedNodeList: SubscriptionNode[] = addSubscriptionNodeFields(data);
        const attributeCountFromDraft: number =
          draftedSubscriptionNodes.length == 0 ? 0 : findLeavesOfNodeList(draftedSubscriptionNodes);
        const newApprovedAttributes: SubscriptionNode[] = addAttributesFromDraft(formattedNodeList, draftedSubscriptionNodes);

        const newFormattedApprovedAttributes: SubscriptionNode[] = JSON.parse(
          JSON.stringify(newApprovedAttributes) // deep copy
        );
        const newFilteredApprovedAttributes: SubscriptionNode[] = JSON.parse(
          JSON.stringify(newApprovedAttributes) // deep copy
        );

        setFormattedSubscriptionNodes(newFormattedApprovedAttributes);
        setFilteredSubscriptionNodes(newFilteredApprovedAttributes);
        setCheckedAttributeCount(attributeCountFromDraft);
        setIsAttributeSubscriptionLoading(false);
      })
      .catch((error) => {
        if (cancelled) return;
        setFormattedSubscriptionNodes([]);
        setFilteredSubscriptionNodes([]);
        setCheckedAttributeCount(0);
        setIsAttributeSubscriptionLoading(false);
      });
    return () => { cancelled = true; };
  }, [environment, egressOptions]);

  useEffect(() => {

    const availableAttributesFilteredBySearchQuery: SubscriptionNode[] = filterBySearchQuery(
      formattedSubscriptionNodes,
      searchQuery
    );

    setFilteredSubscriptionNodes(availableAttributesFilteredBySearchQuery);
  }, [searchQuery]);

  return [
    formattedSubscriptionNodes,
    setFormattedSubscriptionNodes,
    filteredSubscriptionNodes,
    setFilteredSubscriptionNodes,
    checkedAttributeCount,
    setCheckedAttributeCount,
    isAttributeSubscriptionLoading,
  ] as const;
}
